import { Injectable, Provider, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Action } from './models';
export class ScannedActionsSubject extends Subject<Action>
  implements OnDestroy {
/**
 * @return {?}
 */
ngOnDestroy() {
    this.complete();
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ScannedActionsSubject_tsickle_Closure_declarations() {
/** @type {?} */
ScannedActionsSubject.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ScannedActionsSubject.ctorParameters;
}


export const /** @type {?} */ SCANNED_ACTIONS_SUBJECT_PROVIDERS: Provider[] = [
  ScannedActionsSubject,
];

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../modules/store/src/scanned_actions_subject.ts